import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MockupPreviewComponent } from '../mockup-preview/mockup-preview.component';
import { PhotosService } from '../services/photos.service';

@Component({
    selector: 'app-facebook-post',
    templateUrl: './facebook-post.component.html',
    styleUrls: ['./facebook-post.component.css']
})
export class FacebookPostComponent implements OnInit {
    facebookPost = [];

    constructor(private photos: PhotosService, public dialog: MatDialog) { }

    ngOnInit() {
        this.facebookPost = this.photos.facebookPost;
    }

    openDialog(url: string): void {
        if (screen.width > 600) {
            this.dialog.open(MockupPreviewComponent, {
                maxHeight: '90%',
                width: '900px',
                data: {url: url}
            });
        }
    }

}
